'use strict';

import searchInputTemplate from './searchInput.component.html';

export default angular
  .module('maestro.directives.components.search-input', [])

  .directive('appSearchInput', function() {
    return {
      restrict: 'E',
      template: searchInputTemplate,
      scope: {
        ngModel: '=', // String bind to search text, string
        delay: '@', // Delay - int in ms
        debounce: '@', // Search on typing
        loading: '<', // Loading indicator, bool
        disabled: '<', // Disabled state, bool
        onSearch: '&', // On search callback
        placeholder: '@'
      },
      controller: $scope => {
        const defaultDelay = 2000;
        initNgModelOptions();

        $scope.search = (val) => {
          $scope.onSearch({ text: val });
        };

        $scope.clearSearch = () => {
          $scope.ngModel = '';
        };

        $scope.$watch('ngModel', (newValue, oldValue) => {
          if (newValue == oldValue) {
            return;
          }
          $scope.search(newValue);
        });

        $scope.$watchGroup(['debounce', 'delay'], () => {
          initNgModelOptions();
        });

        function initNgModelOptions() {
          $scope.ngModelOptions = {
            updateOn: 'blur submit'
          };

          if ($scope.debounce === 'true' || $scope.debounce === true) {
            let delay = parseInt($scope.delay, 10);
            if (isNaN(delay)) {
              delay = defaultDelay;
            } else if (delay < 0) {
              delay = 0;
            }
            $scope.ngModelOptions = {
              updateOn: 'default blur submit',
              debounce: { 'default': delay, 'blur': 0, 'submit': 0 }
            };
          }
        }
      }
    };
  })

  .name;
